<input type="file" class="hidden" ngFileSelect [options]="options"
	(uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
